<template>
    <el-dialog
        :title="'发送会员'"
        :visible.sync="chioseDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="1200px"
        center>
        <div class="padding-tb">
            <div class="flex align-center margin-bottom-sm">
                <span>标签选择：</span>
                <el-select
                    v-model="label"
                    multiple
                    clearable
                    filterable
                    placeholder="请选择标签"
                    class="flex-sub"
                    @change="chioseMember">
                    <el-option
                        v-for="(item, index) in labels"
                        :key="index"
                        :label="item.name"
                        :value="index"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class="flex align-start margin-bottom-sm">
                <span class="label-title">会员选择：</span>
                <div class="flex-sub width-100">
                    <el-transfer
                        ref="memberTransfer"
                        class="flex width-100 align-center"
                        v-model="value"
                        filterable
                        :titles="['全部会员', '已选择会员']"
                        :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}',
            }"
                        :props="{
              key: 'user_id',
              label: 'company',
            }"
                        :data="memberList"
                    >
                        <span slot-scope="{ option }">{{ option.label }}</span>
                    </el-transfer>
                </div>
            </div>
            <div class="flex align-center justify-around">
                <el-button style="width: 200px" class="font-size" @click="cancelChiose"
                >关闭
                </el-button
                >
                <el-button
                    style="width: 200px"
                    type="primary"
                    class="font-size"
                    @click="labelSave"
                >确定
                </el-button
                >
            </div>
        </div>
    </el-dialog>
</template>

<script>
import {labelSelect, allMember} from '@/api/branch'

export default {
    name: "chioseDialog",
    props: {
        chioseDialog: {
            type: Boolean,
            default: false
        },
        send_user_id:{
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            type: 1,
            labels: [],
            label: [],
            value: [],
            valueObj: [],
            memberList: [],
            renderFunc(h, option) {
                return <span>{option.key} - {option.label}</span>;
            },
        }
    },
    created() {
        this.init()
    },
    methods: {
        //  关闭选择框
        cancelChiose() {
            this.clearSearch()
            this.$emit('cancelChiose')
        },
        //  选择标签保存
        labelSave() {
            if (this.value.length === 0) return this.$message.error('请选择要发送的会员')
            this.valueObj = []
            this.memberList.map(item => {
                this.value.map(id => {
                    if (item.user_id === id) {
                        this.valueObj.push(item)
                    }
                })
            })
            this.clearSearch()
            this.$emit('saveChiose', [1, this.value, this.valueObj])
        },

        //  选择标签 会员数据同步
        chioseMember(val) {
            let _arr = []
            val.map(item => {
                if (this.labels[item].user_id_str) {
                    _arr = [..._arr, ...this.labels[item].user_id_str.split(',').map(Number)]
                    _arr = [...new Set(_arr)]
                }
            })
            this.value = _arr
        },
        clearSearch() {
            this.$refs.memberTransfer.clearQuery('left')
            this.$refs.memberTransfer.clearQuery('right')
        },

        //  获取全部标签和会员
        async init() {
            let _data = await labelSelect()
            this.labels = [..._data.data.rank,..._data.data.fixedFourLable,..._data.data.customLable]

            let _allMember = await allMember()
            _allMember.data.map(item => {
                item.label =  item.user_type === 1 ? item.company  : item.name
                item.key = item.user_id
            })
            this.value = this.send_user_id.map(item=>{
                    return item.user_id
                }
            )
            this.memberList = _allMember.data
        }

    },
    watch: {
        chioseType() {
            this.type = this.chioseType
        }
    }
}
</script>

<style scoped lang="scss">
.chiose-title {
    width: 500px;
    margin: 0 auto;

    span {
        display: block;
        width: 180px;
        height: 40px;
        text-align: center;
        line-height: 38px;
        font-size: 16px;
        border: 1px solid #ccc;
        border-radius: 5px;
        cursor: pointer;

        &.primary {
            background: #0d7fd7;
            color: #fff;
        }
    }
}

.search-some {
    display: flex;
    align-items: center;
    margin-bottom: 20px;

    span {
        display: block;
        width: 80px;
    }

    .el-input {
        flex: 1;
    }

    .el-select {
        flex: 1;
    }
}

.condition-list {
    height: 200px;
    overflow-y: auto;
    border: 1px solid #ccc;
    margin-bottom: 30px;
}
</style>